export default __webpack_public_path__ + "static/articles-2fc65ef888275a39c6fcccb6ac6ca7bf.jpg";